<template>
    <div id="app">
        <div class="errorMsgStyle" v-if="errorStatus">
            <label class="login_errorMessageLabel" id="errorLabel"> {{ errorMessage }} </label>
        </div>

        <router-view />
        <sideBar />
    </div>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import sideBar from "@/components/side-bar.vue";

export default {
    name: "Home",
    components: {
        sideBar,
    },
    data() {
        return {
            form: {
                eml: "",
                pwd: "",
            },
            store: store,
            errorStatus: false,
            errorMessage: "",
        };
    },

    methods: {},
    mounted() {
        this.form.eml = window.localStorage.getItem("LI3EIB"); //Email
        this.form.pwd = window.localStorage.getItem("QW3F4OV6"); //Password

        // Google SSO Login- Start
        var userObj = new URL(location.href).searchParams.get("sso");
        var url = document.location.href;
        if (userObj && userObj != "invalidUser") {
            window.localStorage.setItem("SSOLogin", "true");
            userObj = JSON.parse(userObj.replace(/&/g, '","').replace(/=/g, '":"'));
            var hashReplaceData = JSON.stringify(userObj).replace(/-hash-/g, "#");
            userObj = JSON.parse(hashReplaceData);
            console.log("hash", hashReplaceData);
            console.log("userObj::: ", userObj);
        }
        console.log("SSO Login:: ??  ", window.localStorage.getItem("SSOLogin"));
        // Reintiatiate SSO login
        if (window.localStorage.getItem("SSOLogin") == "true" && userObj == null) {
            window.location.href = "https://inspirediagnostics.app/api/sso/login-saml";
        }

        if (userObj && userObj != "invalidUser") {
            window.localStorage.setItem("token", userObj.token);
            this.store.sessionID = userObj.token;
            this.store.userDetails = userObj;
            this.store.registration.iid = userObj.iid;
            this.store.registration.eml = userObj.eml;
            this.store.registration.mob = userObj.mob;
            this.store.groupDetail.gid = userObj.gid;

            //Setting the App theme based on the response
            document.documentElement.style.setProperty("--appHeaderBgColor", userObj.group.color[0].priclr);
            document.documentElement.style.setProperty("--loginBackgroundColor", userObj.group.color[0].secclr);
            document.documentElement.style.setProperty("--appTitleTxtColor", userObj.group.color[0].btntxtclr);
            document.documentElement.style.setProperty("--primaryTextColor", userObj.group.color[0].pritxtclr);
            document.documentElement.style.setProperty("--textColorLight", userObj.group.color[0].sectxtclr);
            document.documentElement.style.setProperty("--bannerBackgroundColor", userObj.group.color[0].banbgclr);
            document.documentElement.style.setProperty("--errorMessageTextColor", userObj.group.color[0].errtxtclr);

            window.localStorage.setItem("groupID", JSON.stringify(userObj.group.grgcd));
            //Fetching the logo image from api and storing in local storage
            if (userObj.group.cssp.length > 0) {
                window.localStorage.setItem("logo", JSON.stringify(userObj.group.cssp));
                this.store.groupDetail.cssp = JSON.parse(window.localStorage.getItem("logo"));
                this.store.isLogoAvailable = true;
            } else {
                window.localStorage.setItem("gnm", JSON.stringify(userObj.group.gnm));
                this.store.groupDetail.gnm = JSON.parse(window.localStorage.getItem("gnm"));
                this.store.isLogoAvailable = false;
            }

            // Removing Object from URL
            window.history.pushState({}, "", url.split("?")[0]);
            this.$router.push({ path: "/app-home" });
        } else if (userObj == "invalidUser") {
            window.history.pushState({}, "", url.split("?")[0]);
            this.$router.push({ path: "/login" });
        }
        // Google SSO Login- End
        else if (this.form.eml == null) {
            if (JSON.parse(window.localStorage.getItem("disclaimer")) == "false") {
                this.$router.push({ path: "/home" });
            } else {
                this.$router.push({ path: "/disclamier" });
            }
        } else {
            var CryptoJS = require("crypto-js");
            //Email
            var eml = CryptoJS.AES.decrypt(this.form.eml, "eml");
            this.form.eml = eml.toString(CryptoJS.enc.Utf8);
            //Password
            var pwd = CryptoJS.AES.decrypt(this.form.pwd, "pwd");
            this.form.pwd = pwd.toString(CryptoJS.enc.Utf8);
            if (navigator.onLine) {
                var header = {};

                //     headers: [
                //         {
                //             key: "Content-Type",
                //             value: "application/json",
                //             type: "text",
                //         },
                //     ],
                // };

                apiCall
                    .apiServiceCall("Post", "", "/user/login", this.form, header)
                    .then((response) => {
                        if (response.data.status == 1) {
                            this.store.sessionID = response.data.data.token;
                            window.localStorage.setItem("token", response.data.data.token);
                            this.store.userDetails = response.data.data.user;
                            this.store.registration.iid = response.data.data.user.iid;
                            this.store.registration.eml = response.data.data.user.eml;
                            this.store.registration.mob = response.data.data.user.mob;
                            this.store.groupDetail.gid = response.data.data.user.gid;

                            // const data = JSON.stringify(response.data.data.user.iid);
                            // window.localStorage.setItem("iid", data);
                            //Encrypting Email and Password
                            var CryptoJS = require("crypto-js");
                            var eml = CryptoJS.AES.encrypt(this.form.eml, "eml").toString();
                            window.localStorage.setItem("LI3EIB", eml); //Email
                            var pwd = CryptoJS.AES.encrypt(this.form.pwd, "pwd").toString();
                            window.localStorage.setItem("QW3F4OV6", pwd); //Password

                            //Setting the App theme based on the response
                            document.documentElement.style.setProperty("--appHeaderBgColor", response.data.data.group.color[0].priclr);
                            document.documentElement.style.setProperty("--loginBackgroundColor", response.data.data.group.color[0].secclr);
                            document.documentElement.style.setProperty("--appTitleTxtColor", response.data.data.group.color[0].btntxtclr);
                            document.documentElement.style.setProperty("--primaryTextColor", response.data.data.group.color[0].pritxtclr);
                            document.documentElement.style.setProperty("--textColorLight", response.data.data.group.color[0].sectxtclr);
                            document.documentElement.style.setProperty(
                                "--bannerBackgroundColor",
                                response.data.data.group.color[0].banbgclr
                            );
                            document.documentElement.style.setProperty(
                                "--errorMessageTextColor",
                                response.data.data.group.color[0].errtxtclr
                            );

                            window.localStorage.setItem("groupID", JSON.stringify(response.data.data.group.grgcd));
                            //Fetching the logo image from api and storing in local storage
                            if (response.data.data.group.cssp.length > 0) {
                                window.localStorage.setItem("logo", JSON.stringify(response.data.data.group.cssp));
                                this.store.groupDetail.cssp = JSON.parse(window.localStorage.getItem("logo"));
                                this.store.isLogoAvailable = true;
                            } else {
                                window.localStorage.setItem("gnm", JSON.stringify(response.data.data.group.gnm));
                                this.store.groupDetail.gnm = JSON.parse(window.localStorage.getItem("gnm"));
                                this.store.isLogoAvailable = false;
                            }
                            this.$router.push({ path: "/app-home" });
                        } else {
                            this.store.isLoginError = true;
                            this.store.loginErrorMsg = response.data.message;
                            this.$router.push({ path: "/login" });
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 401) {
                            setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                        } else if (error.response.status == 504) {
                            this.signout();
                        } else {
                            this.store.isLoginError = true;
                            this.store.loginErrorMsg = error.response.data.message;
                            this.$router.push({ path: "/login" });
                        }
                    });
            } else {
                this.store.isLoginError = true;
                this.store.loginErrorMsg = this.checkInternetConnection;
                this.$router.push({ path: "/login" });
            }
        }
    },
};
</script>